import { getNStatusLabel } from "@/lib/utils/recommendation";
import { NStatus } from "@/types/field";
import { Chip } from "@heroui/react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

function NStatusChip({
    nStatus,
    sufficiency,
    fullWidth,
}: {
    nStatus: NStatus | null;
    sufficiency?: number | null;
    fullWidth?: boolean;
}) {
    const { t } = useTranslation("fields-list");

    return (
        <Chip
            radius="sm"
            size="sm"
            className={fullWidth ? "w-full max-w-full" : ""}
            classNames={{
                base: classNames({
                    "text-white": true,
                    "bg-red-100": nStatus === "red",
                    "bg-green-100": nStatus === "green",
                    "bg-yellow-100": nStatus === "yellow",
                    "!w-full !max-w-full !flex !justify-center": fullWidth,
                }),
                content: classNames({
                    "font-bold": true,
                    "text-red-700": nStatus === "red",
                    "text-green-700": nStatus === "green",
                    "text-yellow-700": nStatus === "yellow",
                    "!justify-center !w-full !text-center": fullWidth,
                }),
            }}
        >
            {sufficiency
                ? `${sufficiency.toFixed(1)}%`
                : nStatus
                  ? getNStatusLabel(nStatus, t)
                  : t("no-data")}
        </Chip>
    );
}

export default NStatusChip;
